import React, { useState } from 'react';
import './loading-dots.css';
import styles from './Settings.module.css';
import { useDarkMode } from '../DarkModeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import ProfilCard from './ProfilCard';
import PreferinteCard from './PreferinteCard';
import ResetareProgres from './ResetareProgres/ResetareProgres';
import SchimbareParolaCard from './SchimbareParolaCard';
import DetaliiPlanCard from './DetaliiPlanCard';
import InchidereContCard from './InchidereContCard';
import AsistentaCard from './AsistentaCard';
import SettingsTabMenu from './SettingsTabMenu';
import { redirectToLogin } from '../utils/authRedirect';
import NotificariCard from './NotificariCard';

import '../content/functionalpagelogin/leftSidebar/pages/reglaredimensiune.css';	

const TABS = [
  { key: 'profil', label: 'Profil' },
  { key: 'preferinte', label: 'Preferinte' },
  { key: 'notificari', label: 'Notificari' },
  { key: 'resetare-progres', label: 'Resetare progres' },
];


const apiUrl = process.env.REACT_APP_API_URL;

const Settings = ({ activeTab, setActiveTab, onBackToProfile }) => {
 const [userData, setUserData] = useState(null);
 const [loading, setLoading] = useState(true);
 const [selectedFile, setSelectedFile] = useState(null);
 const [previewImage, setPreviewImage] = useState(null);
 const [successMessage, setSuccessMessage] = useState('');
 const [username, setUsername] = useState('');
 const [soundEffects, setSoundEffects] = useState(true);
 const [currentPassword, setCurrentPassword] = useState('');
 const [newPassword, setNewPassword] = useState('');
 const [confirmPassword, setConfirmPassword] = useState('');
 const [showCurrentPassword, setShowCurrentPassword] = useState(false);
 const [showNewPassword, setShowNewPassword] = useState(false);
 const [passwordError, setPasswordError] = useState('');
 const [passwordSuccess, setPasswordSuccess] = useState('');
 const [hasPassword, setHasPassword] = useState(true);
 const { darkMode, setDarkMode } = useDarkMode();

 // Fetch user data from server (logic adapted from Setari.jsx)
 React.useEffect(() => {
		const fetchUserData = async () => {
			try {
				const response = await fetch(`${apiUrl}/user`, {
					method: 'GET',
					credentials: 'include',
				});
				if (response.ok) {
					const data = await response.json();
					setUserData(data);
					setUsername(data.username || '');
					setHasPassword(data.has_password !== false);

if (typeof data.dark_mode === 'boolean') {
  setDarkMode(data.dark_mode); // sincronizează cu valoarea din backend
}

if (typeof data.sound_effects === 'boolean') {
  setSoundEffects(data.sound_effects);
}

					// setDarkMode vine din context, deci nu mai e nevoie să-l setăm aici
				} else {
					setUserData({
						username: 'Vizitator',
						email: '',
						profile_picture: '',
						account_type: 'free',
						is_active: false
					});
				}
			} catch (err) {
				setUserData({
					username: 'Vizitator',
					email: '',
					profile_picture: '',
					account_type: 'free',
					is_active: false
				});
			} finally {
				setLoading(false);
			}
		};
		fetchUserData();
	}, []);

	// Profile picture handlers
	const handleFileChange = (event) => {
		const file = event.target.files[0];
		if (!file) return;
		setSelectedFile(file);
		const reader = new FileReader();
		reader.onloadend = () => {
			setPreviewImage(reader.result); // base64 data URL
		};
		reader.readAsDataURL(file);
	};

	const uploadProfilePicture = async () => {
		if (!previewImage) return;
		try {
			const response = await fetch(`${apiUrl}/user/update-profile-picture`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'include',
				body: JSON.stringify({ profile_picture: previewImage }),
			});
			const result = await response.json();
			if (response.ok) {
				setUserData(prev => ({ ...prev, profile_picture: result.profile_picture }));
				setPreviewImage(null);
				setSelectedFile(null);
				setSuccessMessage('Imaginea a fost actualizată cu succes.');
				setTimeout(() => setSuccessMessage(''), 3000);
			} else {
				setSuccessMessage(result.message || 'Eroare la actualizarea imaginii.');
				setTimeout(() => setSuccessMessage(''), 3000);
			}
		} catch (err) {
			console.error('Eroare la încărcarea imaginii:', err);
			setSuccessMessage('A apărut o eroare.');
			setTimeout(() => setSuccessMessage(''), 3000);
		}
	};

	const onProfilePictureDelete = async () => {
		if (!window.confirm('Ești sigur că dorești să ștergi imaginea de profil?')) return;
		try {
			const response = await fetch(`${apiUrl}/user/delete-profile-picture`, {
				method: 'DELETE',
				credentials: 'include',
			});
			if (response.ok) {
				setUserData(prev => ({ ...prev, profile_picture: '' }));
				setPreviewImage(null);
				setSelectedFile(null);
				setSuccessMessage('Imaginea de profil a fost ștearsă.');
				setTimeout(() => setSuccessMessage(''), 3000);
			}
		} catch (err) {
			console.error('Eroare la ștergerea imaginii:', err);
		}
	};
	const onProfileSave = async (e) => {
		e.preventDefault();
		try {
			const response = await fetch(`${apiUrl}/user/update-username`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'include',
				body: JSON.stringify({ username }),
			});
			if (response.ok) {
				const data = await response.json();
				setUserData(prev => ({ ...prev, username: data.username }));
				setSuccessMessage('Profilul a fost salvat!');
				setTimeout(() => setSuccessMessage(''), 3000);
			} else {
				const err = await response.json();
				setSuccessMessage(err.message || 'Eroare la salvare');
				setTimeout(() => setSuccessMessage(''), 3000);
			}
		} catch {
			setSuccessMessage('Eroare la salvare');
			setTimeout(() => setSuccessMessage(''), 3000);
		}
	};
	const handleDarkModeToggle = async () => {
  const newMode = !darkMode;
  setDarkMode(newMode); // actualizează local tema

  try {
    const response = await fetch(`${apiUrl}/user/theme`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // pentru a trimite cookie-ul JWT
      body: JSON.stringify({ dark_mode: newMode }),
    });

    if (!response.ok) {
      throw new Error('Eroare la salvarea preferinței de temă');
    }

    console.log('✔️ Tema a fost actualizată pe server:', newMode);
  } catch (error) {
    console.error('❌ Eroare la trimiterea preferinței:', error);
  }
};

	const handleSoundEffectsToggle = async () => {
		const newValue = !soundEffects;
		setSoundEffects(newValue);

		try {
			const response = await fetch(`${apiUrl}/user/sound-effects`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				credentials: 'include',
				body: JSON.stringify({ sound_effects: newValue }),
			});

			if (!response.ok) {
				throw new Error('Eroare la salvarea preferintelor de sunet');
			}
		} catch (error) {
			console.error('Eroare la actualizarea efectelor sonore:', error);
			setSoundEffects(!newValue);
		}
	};




const handleResetProgress = async () => {
  const response = await fetch(`${apiUrl}/user/reset-progress`, {
    method: 'DELETE',
    credentials: 'include',
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data.message || 'Progresul nu a putut fi resetat.'
    );
  }

  return data;
};







	const handleChangePassword = e => { e.preventDefault(); setPasswordSuccess('Parola schimbată!'); setPasswordError(''); };
	const handleDeleteAccount = () => { alert('Cont șters!'); };

	 // activeTab și setActiveTab vin din props

	// Responsive: pe mobil afișezi doar cardul selectat cu buton Înapoi, fără meniu
	const [showCardMobile, setShowCardMobile] = useState(false); // false: vezi lista, true: vezi cardul
	const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
	const isMobile = windowWidth <= 1100;

	React.useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// Pe mobil: click pe tab => vezi cardul, click pe Înapoi => vezi lista
	 const handleTabClick = (key) => {
		 setActiveTab(key);
		 if (isMobile) setShowCardMobile(true);
	 };
	const handleBackMobile = () => setShowCardMobile(false);

	if (loading) return (
	  <div className="welcome-screen-lesson">
	    <div className="loading-dots">
	      <span></span>
	      <span></span>
	      <span></span>
	    </div>
	  </div>
	);

	return (
		<div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank"></div>
			
			{/* Breadcrumb și titlu ca în About.jsx, doar pe desktop */}
			{/* Desktop: doar conținutul tabului activ, fără meniu */}
			{!isMobile && (
				<div className={styles.settingsContainer}>
					<div className={styles.tabContent}>
						{activeTab === 'profil' && (
							<ProfilCard
								userData={userData}
								onProfilePictureChange={handleFileChange}
								onProfilePictureDelete={onProfilePictureDelete}
								onProfileSave={onProfileSave}
								selectedFile={selectedFile}
								previewImage={previewImage}
								successMessage={successMessage}
								handleFileChange={handleFileChange}
								uploadProfilePicture={uploadProfilePicture}							username={username}
							onUsernameChange={setUsername}							/>
						)}
						{activeTab === 'preferinte' && (
							<PreferinteCard
								darkMode={darkMode}
								soundEffects={soundEffects}
								handleDarkModeToggle={handleDarkModeToggle}
								handleSoundEffectsToggle={handleSoundEffectsToggle}
							/>
						)}
						{activeTab === 'notificari' && (
						<NotificariCard />
						)}
						{activeTab === 'resetare-progres' && (
							<ResetareProgres
  onResetProgress={handleResetProgress}
/>
							)}
													{activeTab === 'plan' && <DetaliiPlanCard plan={{
							name: userData?.plan_name || 'PERSONAL',
							startDate: userData?.plan_start || '01/12/2024',
							endDate: userData?.plan_end || '01/12/2025',
							nextBilling: userData?.plan_next_billing || '02/12/2024',
							paymentMethod: userData?.plan_payment_method || 'Card •••• 1234',
						}} />}
						{/* Buton de Deconectare */}
						
					</div>
				</div>
			)}
			{/* Mobil: overlay/modal peste tot */}
			{isMobile && (
				<div className={styles.mobileOverlay}>
					{!showCardMobile ? (
						<div className={styles.mobileMenuCard}>
							<div className={styles.mobileMenuHeader}>
								<span
									className={styles.mobBackIcon}
									onClick={() => {
										if (typeof onBackToProfile === 'function') {
											onBackToProfile();
											return;
										}
										window.history.back();
									}}
								>
									<FontAwesomeIcon icon={faChevronLeft} />
								</span>
								<span className={styles.mobileMenuTitle} style={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>Setari</span>
								{/* Eliminat butonul verde 'Gata' */}
							</div>
						<div className={styles.mobileMenuListRows}>
							{TABS.map(tab => (
								<div key={tab.key} className={styles.mobileMenuRowCard}>
									<button
										className={styles.mobileMenuRowInner}
										onClick={() => handleTabClick(tab.key)}
									>
										<span>{tab.label}</span>
										<span className={styles.mobileMenuArrow}>&#8250;</span>
										</button>
									</div>
								))}
								{/* Buton Deconectare mobil */}
							<div className={styles.mobileMenuRowCard}>
								<button
									className={styles.mobileMenuRowInner}
									onClick={() => {
										fetch(`${apiUrl}/logout`, { method: 'POST', credentials: 'include' })
											.then(() => redirectToLogin());
									}}
								>
									<FontAwesomeIcon icon="fa-right-from-bracket" className={styles.logoutIcon} />
										Deconectare
									</button>
								</div>
							</div>
						</div>
					) : (
						<div className={styles.mobSectionCard}>
							<div className={styles.mobSectionHeader}>
								<span className={styles.mobBackIcon} onClick={handleBackMobile}>
									<FontAwesomeIcon icon={faChevronLeft} />
								</span>
								<div className={styles.mobSectionTitle}>{TABS.find(t => t.key === activeTab)?.label}</div>
								
							</div>
						<div className={styles.mobSectionContent}>
							<div className={styles.mobSectionInner}>
									{activeTab === 'profil' && (
										<ProfilCard
											userData={userData}
											onProfilePictureChange={handleFileChange}
											onProfilePictureDelete={onProfilePictureDelete}
											onProfileSave={onProfileSave}
											selectedFile={selectedFile}
											previewImage={previewImage}
											successMessage={successMessage}
											handleFileChange={handleFileChange}
											uploadProfilePicture={uploadProfilePicture}
											username={username}
											onUsernameChange={setUsername}
										/>
									)}
									{activeTab === 'preferinte' && (
										<PreferinteCard
											darkMode={darkMode}
											soundEffects={soundEffects}
											handleDarkModeToggle={handleDarkModeToggle}
											handleSoundEffectsToggle={handleSoundEffectsToggle}
										/>
									)}
									{activeTab === 'notificari' && (
									<NotificariCard />
									)}
									{activeTab === 'resetare-progres' && (
									<ResetareProgres
  onResetProgress={handleResetProgress}
/>
									)}
									{activeTab === 'plan' && <DetaliiPlanCard plan={{
										name: userData?.plan_name || 'PERSONAL',
										startDate: userData?.plan_start || '01/12/2024',
										endDate: userData?.plan_end || '01/12/2025',
										nextBilling: userData?.plan_next_billing || '02/12/2024',
										paymentMethod: userData?.plan_payment_method || 'Card •••• 1234',
									}} />}
								</div>
							</div>
						</div>
					)}
				</div>
			)}

<div className="right-elements-componentsmenu-settins">
				<SettingsTabMenu activeTab={activeTab} onTabClick={setActiveTab} />
			</div>

		</div>
	);
};

export default Settings;
